<template>
  <Modal
    title="Create Time Widget"
    @closeModal="$emit('closeModal')"
    :okButtonLabel="'Create'"
    :disabled="widgetName.length < 3"
    :okFunction="createWidget"
    :modalStyles="{ width: '500px' }"
    :cancelButtonLabel="'Cancel'"
  >
    <template #body>
      <div class="form-group layout-input">
        <label>Widget Name</label>
        <input
          type="text"
          class="form-control"
          v-model="widgetName"
          placeholder="Enter widget name"
        />
      </div>

      <div class="form-group layout-input grouped-inputs">
        <div class="input-item">
          <label>Clock Type</label>
          <select class="form-control" v-model="clockType">
            <option :value="TIME_CLOCK_TYPE.DIGITAL">Digital Clock</option>
            <option :value="TIME_CLOCK_TYPE.ANALOG">Analog Clock</option>
          </select>
        </div>

        <div class="input-item">
          <label>Time Format</label>
          <select class="form-control" v-model="timeFormat">
            <option :value="TIME_FORMAT.TWELVE">12 hours</option>
            <option :value="TIME_FORMAT.TWENTY_FOUR">24 hours</option>
          </select>
        </div>
      </div>

      <div class="form-group layout-input">
        <label>Timezone</label>
        <select class="form-control" v-model="timezone">
          <option v-for="timezone in TIMEZONES" :key="timezone.value" :value="timezone.value">
            {{ timezone.label }}
          </option>
        </select>
      </div>
    </template>
  </Modal>
</template>

<script>
  import Modal from '@/components/common/Modal.vue';
  import {
    timeDefaultOptions,
    TIMEZONES,
    TIME_CLOCK_TYPE,
    TIME_FORMAT,
  } from '@/constant/timeWidget.js';

  export default {
    name: 'CreateTimeWidgetModal',

    components: {
      Modal,
    },

    data() {
      return {
        widgetName: timeDefaultOptions.name,
        clockType: timeDefaultOptions.clockType,
        timezone: timeDefaultOptions.timezone,
        timeFormat: timeDefaultOptions.format,
        fontColor: timeDefaultOptions.fontColor,
        TIMEZONES,
        TIME_CLOCK_TYPE,
        TIME_FORMAT,
      };
    },

    methods: {
      createWidget() {
        const configData = {
          name: this.widgetName,
          time: {
            clockType: this.clockType,
            timezone: this.timezone,
            timeFormat: this.timeFormat,
            fontColor: this.fontColor,
          },
        };

        this.$emit('createWidget', configData);
        this.$emit('closeModal');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .form-group {
    width: 100%;
  }

  .row {
    display: flex;
    margin-left: -15px;
    margin-right: -15px;
  }

  .col-6 {
    flex: 0 0 50%;
    max-width: 50%;
    padding-left: 15px;
    padding-right: 15px;
  }

  .grouped-inputs {
    display: flex;
    gap: 15px;

    .input-item {
      flex: 1;
    }
  }
</style>
